export const GET_LOGS_LOADING='get/logs/loading';
export const GET_LOGS_SUCCESS='get/logs/success';
export const GET_LOGS_FAILURE='get/logs/failure';

export const SET_LOG_LOADING='set/log/loading';
export const SET_LOG_SUCCESS='set/log/success';
export const SET_LOG_FAILURE='set/log/failure';